<template>
  <nav>
    <v-navigation-drawer
      v-if="showLogoutButton && getDrawer"
      class="application__nav"
      app
      permanent
      dark
      flex
      width="220"
    >
     <v-layout align-left flex-start column fill-height>
      <v-toolbar flat>
        <v-list>
          <v-list-tile>
            <v-list-tile-title>
              <div class="app-logo">XProperty</div>
            </v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-toolbar>
      <v-divider></v-divider>
      <v-list>
        <v-list-tile v-for="link in links" :key="link.text" router :to="link.route">
          <v-list-tile-action>
            <v-icon class="white--text" :color="link.color">{{ link.icon }}</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title class="white--text">
              {{ link.text }}
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>

      <v-list class="end-of-drawer">
        <v-list-tile v-for="link in secondLinks" :key="link.text" router :to="link.route">
          <v-list-tile-action>
            <v-icon class="white--text" :color="link.color">{{ link.icon }}</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title class="white--text">
              {{ link.text }}
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
     </v-layout>
    </v-navigation-drawer>
  </nav>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
export default {
  data() {
    return {
      links: [
        { icon: 'home', color:"blue", text: 'House List', route: '/houses' },
        { icon: 'receipt', color:"orange", text: 'Payments', route: '/payments' },
        // { icon: 'settings', color:"silver", text: 'Configuration', route: '/Configuration' },
      ],
      secondLinks: [
        // { icon: 'handyman', color:"brown", text: 'Issues', route: '/issues' },
        { icon: 'alarm', color:"yellow", text: 'Leases', route: '/leases' },
        { icon: 'handyman', color:"brown", text: 'Repairs', route: '/repairs' },
      ],
    }
  },
  computed: {
    ...mapGetters({
      showLogoutButton: 'User/getIsAuthenticated',
      getDrawer: 'User/getDrawer',
    }),
  },
  methods: {
    ...mapMutations({
      setDrawer: 'User/setDrawer',
    }),
    hideDrawer() {
        this.setDrawer(false)
    },
  },
}
</script>

<style scoped>
.end-of-drawer {
  margin-top: auto;
}
</style>